export const DEFAULT_COLOR_TAG = '#333333';
